import React, { useContext, useMemo, useState } from "react"
import { useSelector } from "react-redux"
import { ReportContext } from "../ReportContext"
import { RateAndAccuracyDescription } from "../Style"
import { useTheme } from "styles"
import { Chip } from "components/Form"
import { Top } from "styles/GlobalStyle"
import { ratingListLabel3, ratingListLabel4, ratingListLabel6 } from "keys/rating"
import FactoredPercentAccuracyTooltip from "../FactoredPercentAccuracyTooltip"
import FluencyTooltip from "../FluencyTooltip"
import { Tooltip } from "@mui/material"
import { RatingTooltip } from "components/Rating"
import { prosodies } from "keys"
import { keyBy } from "lodash"
import { useQueryClient } from "@tanstack/react-query"
import qc from "keys/queryClient"

const reading_fluency = {
    5: "מקוטע מאד",
    4: "מקוטע",
    3: "מעט מקוטע",
    2: "ברצף",
    1: "ברצף +"
}

const useRateAndAccuracyItems = () => {
    const {
        rating: ratingData,
        factoredAccuracyDistribution, correctWordsPerMinuteDistribution, accuracyDistribution, fluencyReadingDistribution, wpmDistribution, factoredAccuracyStats, correctWordsPerMinuteStats, refetchCorrectWordsPerMinuteStats, fluencyReadingStats, refetchFluencyReadingStats, accuracyStats, fluencyStats,
        refetchAccuracyStats, refetchFactoredAccuracyStats, refetchFluencyStats
    } = useContext(ReportContext)

    const queryClient = useQueryClient()
    const scoreRating = queryClient.getQueryData([qc.ratings])

    const sr = scoreRating || {}
    const rating = ratingData.data || {}

    const { assessment } = useSelector(state => state.assessment)
    // const { rating } = useSelector(state => state.rating)
    const { Layout, Common } = useTheme()
    const { fluency_reading, fluency_reading_rating_id, fluency_reading_rating_index, percent_accuracy = "?", num_words_per_minute, factored_percent_accuracy, factored_percent_accuracy_rating_index, percent_accuracy_rating_index, factored_percent_accuracy_rating_id, percent_accuracy_rating_id, correct_words_per_minute = "?", words_per_minute_rating_id, words_per_minute_rating_index, correct_words_per_minute_rating_index, correct_words_per_minute_rating_id } = rating || {}

    // const { rating: accuracy_rating, f_rating, color: accuracyColor, bg: accuracyBg } = sr[percent_accuracy_rating_id] || {}
    const { rating: accuracy_rating, f_rating, color: accuracyColor, bg: accuracyBg } = sr[percent_accuracy_rating_index - 1] || {}

    // const { rating: correct_words_per_minute_rating, f_rating: f_correct_words_per_minute, color: correct_words_per_minute_color, bg: correct_words_per_minute_bg } = sr[correct_words_per_minute_rating_id] || {}
    const { rating: correct_words_per_minute_rating, f_rating: f_correct_words_per_minute, color: correct_words_per_minute_color, bg: correct_words_per_minute_bg } = sr[correct_words_per_minute_rating_index - 1] || {}

    // const { rating: factored_rating, color: scColor, bg: scBg } = sr[factored_percent_accuracy_rating_id] || {}
    const { rating: factored_rating, color: scColor, bg: scBg } = sr[factored_percent_accuracy_rating_index - 1] || {}

    // const { color: fluency_reading_rating_color, bg: fluency_reading_rating_bg } = sr[fluency_reading_rating_id] || {}
    const { color: fluency_reading_rating_color, bg: fluency_reading_rating_bg } = sr[fluency_reading_rating_index - 1] || {}

    // const fluency_reading_rating = ratingListLabel3[fluency_reading_rating_index - 1]
    const fluency_reading_rating = ratingListLabel3[fluency_reading_rating_index - 1]

    // const { rating: fluency_rating, color: rateColor, bg: rateBg } = sr[fluency_rating_id] || {}
    const { rating: words_per_minute_rating, color: rateColor, bg: rateBg } = sr[words_per_minute_rating_index - 1] || {}

    const prosodyKeys = keyBy(prosodies, "id")
    const prosody = prosodyKeys[assessment.prosody]

    const rateAndAccuracyItems = useMemo(
        () => [
            {
                label: " מילים נכונות לדקה",
                type: "correct_words_per_minute",
                text: () =>
                    <React.Fragment>
                        {/* <RateAndAccuracyDescription>
                            מילים נכונות לדקה
                        </RateAndAccuracyDescription> */}
                        {correct_words_per_minute_rating &&
                            <Chip color={correct_words_per_minute_color} bg={correct_words_per_minute_bg}>
                                {` ${correct_words_per_minute} מילים - ${correct_words_per_minute_rating}`}
                            </Chip>}
                    </React.Fragment>,
                expand: true,
                showGraphBtns: true,
                stats: correctWordsPerMinuteStats,
                graph: correctWordsPerMinuteDistribution,
                refetch: refetchCorrectWordsPerMinuteStats,
            },
            {
                label: "קצב",
                type: "fluency",
                text: () =>
                    <React.Fragment>
                        <RateAndAccuracyDescription>
                            מילים לדקה
                        </RateAndAccuracyDescription>
                        <div className="result-rating">
                            {words_per_minute_rating &&
                                <Chip color={rateColor} bg={rateBg}>
                                    {` ${num_words_per_minute} מילים - ${words_per_minute_rating} `}
                                </Chip>}
                            <Top top={-7}>
                                <RatingTooltip selectedIndex={words_per_minute_rating_index} />
                            </Top>
                        </div>
                    </React.Fragment>,
                color: rateColor,
                percent: false,
                expand: true,
                showGraphBtns: true,
                stats: fluencyStats,
                graph: wpmDistribution,
                refetch: refetchFluencyStats
            },
            {
                label: "דיוק (משוקלל)",
                type: "factored_accuracy",
                graph: "graph",
                tooltip: FactoredPercentAccuracyTooltip,
                text: () =>
                    <React.Fragment>
                        <RateAndAccuracyDescription className="description-with-tooltip">
                            אחוז דיוק (משוקלל)
                        </RateAndAccuracyDescription>
                        <div className="result-rating">
                            {factored_rating &&
                                <Chip color={scColor} bg={scBg}>
                                    {`  ${factored_percent_accuracy}% - ${factored_rating}`}
                                </Chip>}
                            <Top top={-7}>
                                <RatingTooltip selectedIndex={factored_percent_accuracy_rating_index} />
                            </Top>
                        </div>
                    </React.Fragment>,
                percent: true,
                expand: true,
                showGraphBtns: true,
                stats: factoredAccuracyStats,
                graph: factoredAccuracyDistribution,
                refetch: refetchFactoredAccuracyStats
            },
            {
                label: "דיוק (גוֺלְמִי)",
                type: "accuracy",
                graph: "graph",
                text: () =>
                    <React.Fragment>
                        <RateAndAccuracyDescription>
                            אחוז דיוק לא משוקלל
                        </RateAndAccuracyDescription>
                        <div className="result-rating">
                            {accuracy_rating &&
                                <Chip color={accuracyColor} bg={accuracyBg}>
                                    {` ${percent_accuracy}% - ${accuracy_rating}`}
                                </Chip>}
                            <Top top={-7}>
                                <RatingTooltip selectedIndex={percent_accuracy_rating_index} />
                            </Top>
                        </div>
                    </React.Fragment>
                ,
                percent: true,
                expand: true,
                showGraphBtns: true,
                stats: accuracyStats,
                graph: accuracyDistribution,
                refetch: refetchAccuracyStats
            },
            {
                label: "רצף",
                type: "reading_fluency",
                tooltip: FluencyTooltip,
                text: () =>
                    <React.Fragment>
                        <RateAndAccuracyDescription style={{ ...Layout.flex }}>
                            אופן הקריאה
                        </RateAndAccuracyDescription>
                        <div className="result-rating">
                            {fluency_reading_rating &&
                                <Chip color={fluency_reading_rating_color} bg={fluency_reading_rating_bg}>
                                    {fluency_reading_rating}
                                </Chip>}
                            <Top top={-7}>
                                <RatingTooltip rating={ratingListLabel6} selectedIndex={fluency_reading_rating_index} />
                            </Top>
                        </div>
                    </React.Fragment>,
                expand: true,
                showGraphBtns: true,
                stats: fluencyReadingStats,
                graph: fluencyReadingDistribution,
                refetch: refetchFluencyReadingStats
            }
        ], [assessment.prosody, correctWordsPerMinuteDistribution, fluencyReadingDistribution, fluencyReadingStats, correctWordsPerMinuteStats, rating, scoreRating, factoredAccuracyDistribution, accuracyDistribution, wpmDistribution, factoredAccuracyStats, accuracyStats, fluencyStats]
    )

    const prosodyItem = {
        label: "",
        type: "correct_words_per_minute",
        text: () =>
            <React.Fragment>
                <RateAndAccuracyDescription>
                    פרוזודיה
                </RateAndAccuracyDescription>
                <Chip color={prosody?.color}>
                    {prosody?.name}
                </Chip>
            </React.Fragment>,
        expand: false,
        showGraphBtns: false,
    }

    return assessment.prosody ?
        [
            ...rateAndAccuracyItems,
            assessment.prosody && prosodyItem
        ]
        : rateAndAccuracyItems
}

export default useRateAndAccuracyItems
